import router from './router'
import store from './store'
import storage from 'store'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import notification from 'ant-design-vue/es/notification'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { i18nRender } from '@/locales'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

// 'login2',
const allowList = ['login', 'register', 'forgetPassword', 'wxLogin', 'aliLogin', '/callback', '/auth-redirect', '/bind', '/DataScreen/DataScreen'] // no redirect allowList
const loginRoutePath = '/user/login'
// const loginRoutePath = '/user/login2'
let defaultRoutePath = '/DataScreen/DataScreen'

router.beforeEach((to, from, next) => {
  // NProgress.start() // start progress bar
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`))
  /* has token */
  if (storage.get(ACCESS_TOKEN)) {
    console.log('getters>>>>>', store.getters)
    if (store.getters.defaultRoutePath) {
      defaultRoutePath = store.getters.defaultRoutePath
    }
    if (to.path === loginRoutePath || to.path === '/') {
      next({ path: defaultRoutePath })
      NProgress.done()
    } else {
      // check login user.roles is null
      if (store.getters.roles.length === 0) {
        // request login userInfo
        store
          .dispatch('GetInfo')
          .then(res => {
            // const roles = res.result && res.result.role
            const roles = res.roles
            // generate dynamic router
            store.dispatch('GenerateRoutes', { roles }).then((accessRoutes) => {
              router.addRoutes(store.getters.routers)
              // router.addRoutes(accessRoutes)
              // 请求带有 redirect 重定向时，登录自动重定向到该地址
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
            })
            /**
             * 提前获取省市区数据
             */
            store.dispatch('getCity')
          })
          .catch(() => {
            notification.error({
              message: '错误',
              description: '请求用户信息失败，请重试'
            })
            // 失败时，获取用户信息失败时，调用登出，来清空历史保留信息
            store.dispatch('Logout').then(() => {
              location.href = '/DataScreen/DataScreen'
            })
          })
      } else {
        next()
      }
    }
  } else {
    if (allowList.includes(to.name)) {
      // 在免登录名单，直接进入
      next()
    } else {
      next({ path: loginRoutePath, query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
router.onError((error) => {
  console.log(error)
  // const pattern = /Loading chunk (\d)+ failed/g
  // const isChunkLoadFailed = error.message.match(pattern)
  // const targetPath = router.history.pending.fullPath
  // if (isChunkLoadFailed) {
  //   router.replace(targetPath)
  // }
})
